import styled, { css } from 'styled-components'
import {
  ITextButton as ITextButtonDS,
  TextButton as TextButtonDS,
  colors,
  fontWeights,
} from '@ads/front-ds'

export interface ITextButton extends ITextButtonDS {
  fontWeight?: keyof typeof fontWeights
  color?: keyof typeof colors
}

export const TextButton = styled(TextButtonDS)<ITextButton>`
  ${p => css`
    font-weight: ${p.fontWeight
      ? p.theme.fontWeights[p.fontWeight]
      : p.theme.fontWeights.regular};
    ${p.color &&
    css`
      color: ${p.theme.colors[p.color]};
    `}
  `}
`
